<div>
  <h2 class="custom-decorated-heading nordic-blue-900-text font-heading-3 mr-small-b pr-large-t">
    {{ 'myTrips.addTrips.title' | finLocalization }}
  </h2>
  <p class="mr-medium-b">{{ 'myTrips.addTrips.description' | finLocalization }}</p>
  <form class="ps-medium-b" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="grid-col-12 ps-clear">
      <div class="col-1-12 sm-col-1-8">
        <fcom-floating-input
          *ngIf="
            formStatus === FormStatus.INITIAL || formStatus === FormStatus.COMPLETE || formStatus === FormStatus.ERROR
          "
          formControlName="bookingReference"
          [type]="'text'"
          [label]="'SERVICE_FORMS.serviceForms.fields.reservationNumber.label' | finLocalization"
          [placeholder]="'SERVICE_FORMS.serviceForms.fields.reservationNumber.placeholder' | finLocalization"
          [required]="true"
          [validationMessages]="validationMessages$ | async"
          [hideError]="hideError"
          (blur)="hideError = false"
        />
        <div *ngIf="formStatus === FormStatus.LOADING" class="relative loader">
          <fcom-loader [loaderType]="LoaderTheme.INLINE" />
        </div>
      </div>
      <div class="col-1-12 sm-col-9-12">
        <fcom-button
          [type]="ButtonType.SUBMIT"
          [disabled]="!form.valid || formStatus === FormStatus.LOADING"
          [text]="'myTrips.addTrips.addButton' | finLocalization"
        />
      </div>
    </div>
  </form>
  <fcom-notification
    *ngIf="formStatus === FormStatus.COMPLETE || formStatus === FormStatus.ERROR"
    aria-live="polite"
    class="pr-small-y pr-clear-t mr-clear block"
    [theme]="formStatus === FormStatus.ERROR ? NotificationTheme.ALERT : NotificationTheme.INFO"
    [iconName]="formStatus === FormStatus.ERROR ? SvgLibraryIcon.INFO : SvgLibraryIcon.CHECKMARK"
  >
    {{ messageLabel | finLocalization }}
  </fcom-notification>
</div>
